import { dataLayerPush } from "./data-layer-push";

const idsToTrack = [
  "job",
  "company",
  "contact",
  "applicationProcess",
  "benefits",
  "about",
  "diversity",
  "experienceReports",
  "faq",
  "faq1",
  "faq2",
  "employer",
  "behindTheScenes",
  "compensation",
  "careerquiz",
  "yourstart",
  "testimonials",
];

// Minimum duration in ms to prevent a DataLayerPush on "Power-Swipes" or fast scrolling behaviour
const MINTIME = 1000;

export function observeElements() {
  // querySelectorAll is in this case better, since we can extract the order of elements of the page
  const components = document.querySelectorAll("[id]");

  if (components.length === 0) {
    return;
  }

  const template: string[] = [];
  let blurred: boolean;
  let start: number | null = null;
  let activeElement: string | null = null;

  function stopTimer() {
    start = null;
    activeElement = null;
  }

  function startTimer(id: string) {
    start = performance.now();
    activeElement = id;
  }

  function getTimeAndPush() {
    if (!(start && activeElement)) {
      return;
    }
    const end = performance.now();
    const totalTimeMs = end - start;
    if (totalTimeMs < MINTIME) {
      stopTimer();
      return;
    }
    dataLayerPush({
      event: "elementInFocus",
      jobAdElementName: activeElement,
      jobAdElementDuration: Math.round(totalTimeMs),
    });
    start = null;
  }

  function onBlur() {
    blurred = true;
    if (activeElement) {
      getTimeAndPush();
    }
  }

  function onFocus() {
    blurred = false;
    // Start counting, if element gets focused again
    if (activeElement) {
      startTimer(activeElement);
    }
  }

  const observer = new IntersectionObserver(
    ([entry]) => {
      if (entry.isIntersecting) {
        // Start of intersection

        if (!blurred) {
          if (activeElement) {
            getTimeAndPush();
          }
          startTimer(entry.target.id);
        }

        dataLayerPush({
          jobAdActiveElement: entry.target.id,
        });
        activeElement = entry.target.id;
      } else if (!blurred && activeElement === entry.target.id) {
        getTimeAndPush();
        stopTimer();
      }
    },
    {
      rootMargin: "-30% 0px -69% 0px",
    }
  );

  for (const comp of components) {
    const componentToTrack = idsToTrack.includes(comp.id);
    if (!componentToTrack) {
      continue;
    }

    template.push(comp.id);
    observer.observe(comp);
  }

  // So we know what order the components are in/what templateConfig we have
  dataLayerPush({
    jobAdTemplate: template.join("/"),
  });

  window.addEventListener("blur", onBlur);
  window.addEventListener("focus", onFocus);

  return function unobserveElements() {
    observer.disconnect();

    window.removeEventListener("blur", onBlur);
    window.removeEventListener("focus", onFocus);
  };
}
